import { paths } from 'src/config/paths'
import { CalculatorIcon } from 'src/shared/components/icons/calculator-icon'
import { LynkIcon } from 'src/shared/components/icons/lynk-icon'
import { ThreePawnIcon } from 'src/shared/components/icons/three-pawn'
import { UploadIcon } from 'src/shared/components/icons/upload-icon'

import type { ULFormData } from '../store/upload-leads-store'
import ClosedDealsStep from '../views/form-steps/closed-deals'
import LeadDistributionStep from '../views/form-steps/lead-distribution'
import LynkStep from '../views/form-steps/lynk'
import MappedFieldsStep from '../views/form-steps/mapped-fields'
import ReuploadLeadsStep from '../views/form-steps/reupload-leads'
import UploadLeadsStep from '../views/form-steps/upload-leads'

export const UPLOAD_LEADS_EXIT_PATH = paths.enterprise.dashboard.pipeline.path

export type FormKeys = keyof ULFormData

export type StepItem = {
  component: React.ReactNode
  /**
   * Acts as a block that prevents access to following steps until required form data is filled.
   */
  requiredFormData?: FormKeys[]
  progress: {
    block: number
    step: number
  }
}

export type UploadLeadsConfig = {
  totalSteps: number
  steps: Partial<Record<ULStepName, StepItem>>
}

export type ULStepName = 'upload' | 'closed-deals' | 'reupload' | 'mapped-fields' | 'lead-distribution' | 'lynk'
export const UL_INITIAL_STEP: ULStepName = 'upload'

const BASE_STEPS: Partial<Record<ULStepName, StepItem>> = {
  upload: {
    component: <UploadLeadsStep />,
    requiredFormData: ['uploadedFile'],
    progress: {
      block: 0,
      step: 1,
    },
  },
  'closed-deals': {
    component: <ClosedDealsStep />,
    requiredFormData: ['closedDeals'],
    progress: {
      block: 0,
      step: 2,
    },
  },
  reupload: {
    component: <ReuploadLeadsStep />,
    progress: {
      block: 0,
      step: 3,
    },
  },
  'mapped-fields': {
    component: <MappedFieldsStep />,
    progress: {
      block: 1,
      step: 1,
    },
  },
  'lead-distribution': {
    component: <LeadDistributionStep />,
    progress: {
      block: 2,
      step: 1,
    },
  },
  lynk: {
    component: <LynkStep />,
    progress: {
      block: 3,
      step: 1,
    },
  },
}

export const UploadLeadsConfig: UploadLeadsConfig = {
  totalSteps: Object.keys(BASE_STEPS).length,
  steps: {
    ...BASE_STEPS,
  },
}

/** The sidebar progress blocks */
export type Block = {
  icon: React.ReactNode
  key: string
  title: string
  /** 0-indexed position of the block in the sidebar */
  blockNumber: number
  /** Number of steps in the block */
  blockSteps: number
}

export const BASE_BLOCKS: Block[] = [
  {
    icon: <UploadIcon size={22} />,
    key: 'upload-leads',
    title: 'Upload Leads',
    blockNumber: 0,
    blockSteps: 2,
  },
  {
    icon: <CalculatorIcon size={22} />,
    key: 'mapping-fields',
    title: 'Mapped Fields',
    blockNumber: 1,
    blockSteps: 1,
  },
  {
    icon: <ThreePawnIcon size={25} />,
    key: 'lead-distribution',
    title: 'Lead Distribution',
    blockNumber: 2,
    blockSteps: 1,
  },
  {
    icon: <LynkIcon size={22} variant="solid" />,
    key: 'lynk',
    title: 'Lynk',
    blockNumber: 3,
    blockSteps: 1,
  },
]
